import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Validators } from '@angular/forms';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-et004-card-IV',
  templateUrl: './et004-card-IV.component.html',
})
export class Et004CardIVComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;
  public listLinhaTratamento?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listLinhaTratamentoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listUnidadeMedidaVelEsteira?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listUnidadeMedidaVelEsteiraOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listTulhaOuSiloDestino?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();
  public listTulhaOuSiloDestinoOriginal?: Array<DropDownListDTO> =
    new Array<DropDownListDTO>();

  @Output() mkCalc = new EventEmitter();
  @Output() mkCalcII = new EventEmitter();

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    public dialog: MatDialog
  ) {
    super('Dados Tratamento', false);
    this.formulario = this.formBuilder.group({
      liberacao_receita_data: [null, [Validators.pattern(this.regexDate)]],
      liberacao_receita_hora: [null, [Validators.pattern(this.regexHour)]],
      inicio_tratamento_data: [null, [Validators.pattern(this.regexDate)]],
      inicio_tratamento_hora: [null, [Validators.pattern(this.regexHour)]],
      termino_tratamento_data: [null, [Validators.pattern(this.regexDate)]],
      termino_tratamento_hora: [null, [Validators.pattern(this.regexHour)]],
      linha_tratamento: [null, []],
      silo_tratamento: [null, []],
      velocidade_bowl_prc: [null, [Validators.max(100)]],
      tempo_descarga_inicio: [null, []],
      tempo_descarga_duracao: [null, []],
      batelada: [null, []],
      peso_total_lote_tratado: [null, []],
      peso_impressao_apos_tratamento: [null, []],
      resp_tratamento: [null, []],
      velocidade_esteira: [null, []],
      unidade_medida_vel_esteira: [null, []],
      temperatura: [null, []],
      lote_fng: [null, []],
      observacao: [null, []],
    });
  }

  async ngOnInit(): Promise<void> {
    this.checkifHasValue(),
    await Promise.all([
      this.getListLinhaTratamento(),
      this.getUnidadeMedidaVelocidadeEsteira(),
      this.getListTulhaOuSiloDestino(),
    ]);
  }

  changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  async getUnidadeMedidaVelocidadeEsteira(): Promise<void> {
    this.listUnidadeMedidaVelEsteira = await this.generalService.getListUnidadeMedidaVelocidadeEsteira();
    this.listUnidadeMedidaVelEsteiraOriginal = this.listUnidadeMedidaVelEsteira;
  }

  async getListLinhaTratamento(): Promise<void> {
    await this.formularioService
      .getListDropDownList('et004', 'linha_tratamento')
      .pipe(take(1))
      .toPromise()
      .then((response) => {
        if (!!response?.data) {
          this.listLinhaTratamento = this.generalService.orderByDropDownList(
            response.data as DropDownListDTO[]
          );
          this.listLinhaTratamentoOriginal = this.listLinhaTratamento;
        }
      })
      .catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(
          error,
          '',
          TypeMessage.ListErrorLinhaTratamento
        );
      });
  }

  checkifHasValue() {
    // Obtém o valor atual de 'silo_tratamento' do formulário
    const value = this.formulario.get('silo_tratamento').value;
    // Verifica se 'value' é um array e se ele contém valores
    if (Array.isArray(value) && value.length > 0) {
      // Transforma o array em uma única string separada por vírgulas
      const stringValue = value.join(', ');
      // Define o valor atualizado de 'silo_tratamento' como a string resultante
      this.formulario.get('silo_tratamento').setValue(stringValue);
    }
  }

  async createFilterLinhaTratamento(value: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listLinhaTratamentoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listLinhaTratamento = this.listLinhaTratamentoOriginal.filter(
          (x) => x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listLinhaTratamento = this.listLinhaTratamentoOriginal;
      }
    } else {
      this.listLinhaTratamento = this.listLinhaTratamentoOriginal;
    }
  }

  async createFilterUnidadeMedidaVelEsteira(value: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listUnidadeMedidaVelEsteiraOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listUnidadeMedidaVelEsteira =
          this.listUnidadeMedidaVelEsteiraOriginal.filter((x) =>
            x.name?.toLowerCase().includes(value?.toLowerCase())
          );
      } else {
        this.listUnidadeMedidaVelEsteira =
          this.listUnidadeMedidaVelEsteiraOriginal;
      }
    } else {
      this.listUnidadeMedidaVelEsteira =
        this.listUnidadeMedidaVelEsteiraOriginal;
    }
  }

  hasSuspendedList: boolean = false
  async getListTulhaOuSiloDestino(): Promise<void> {
    const site = localStorage.getItem('data_site');
    if (site !== 'SHG' && site !== 'TOLL') {
      this.hasSuspendedList = true
      await this.formularioService
        .getListDropDownList('et004', 'nr_tulha_ou_silo_tratamento_destino', site)
        .pipe(take(1))
        .toPromise()
        .then((response) => {
            if (!!response?.data) {
                this.listTulhaOuSiloDestino = this.generalService.orderByDropDownList(
                    response.data as DropDownListDTO[]
                );
                this.listTulhaOuSiloDestinoOriginal = this.listTulhaOuSiloDestino;
            }
        })
        .catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(
                error,
                '',
                TypeMessage.ListErrorTulhaOuSiloDestinoOriginal
            );
        });
      }
  }

  async createFilterTulhaOuSiloDestino(value: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listTulhaOuSiloDestinoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listTulhaOuSiloDestino = this.listTulhaOuSiloDestinoOriginal.filter(
          (x) => x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listTulhaOuSiloDestino = this.listTulhaOuSiloDestinoOriginal;
      }
    } else {
      this.listTulhaOuSiloDestino = this.listTulhaOuSiloDestinoOriginal;
    }
  }                             
  selectionChange() {
    const selectedValuesArray = this.formulario.get('silo_tratamento').value;
    const selectedValuesString = selectedValuesArray.join(', '); // Convertendo o array em uma string separada por vírgula
  }

  async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }
  async makeCalculationsII(): Promise<void> {
    this.mkCalcII.emit();
  }
}
